import React, { createContext, useCallback, useContext, useState } from 'react';
import { noop } from './functions';
import { useI18next } from 'gatsby-plugin-react-i18next';

type LanguageVariant = {
    language: string;
    path: string;
}

const emptyContext = {
    languageVariants: [],
    setLanguageVariants: noop,
};

const LvContext = createContext<{
    languageVariants: LanguageVariant[],
    setLanguageVariants: (variants: LanguageVariant[]) => void,
        }>(emptyContext);

export const LanguageVariantsProvider = (props: React.PropsWithChildren) => {
    const [ languageVariants, updateLanguageVariants ] = useState<LanguageVariant[]>([]);
    const setLanguageVariants = useCallback((values: LanguageVariant[]) => {
        return setTimeout(() => updateLanguageVariants(values), 0);
    }, []);
    return <LvContext.Provider value={{ languageVariants, setLanguageVariants }} {...props}/>;
};

export const useLanguageVariants = () => {
    const ctx = useContext(LvContext);
    return ctx ?? emptyContext;
};

export const buildLanguageLink = (language: string, originalPath: string, path: string, siteUrl: string): string => {
    const isDynamicPath = originalPath.includes('[...]');
    const thisPath = originalPath.includes('.mdx')
        ? path.substring(3)
        : originalPath;
    const url = `${ siteUrl }/${ language }${ !isDynamicPath ? thisPath : '' }`;
    return url.endsWith('/') ? url : `${ url }/`;
};

export const useLanguageLinkBuilder = (configSiteUrl: string): (language?: string) => string => {
    const { language, originalPath, path, siteUrl = configSiteUrl } = useI18next();
    return useCallback((lng: string|null = null) => {
        return buildLanguageLink(lng ?? language, originalPath, path, siteUrl);
    }, [ language, originalPath, path, siteUrl ]);
};
